"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useEffect, useState } from "react";
import ProfileEvent from "@/app/(main)/(club)/mes-clubs/[id]/components/profile-event";
import { getClubDashboard } from "@/app/api/dynabuy-back/api-club";
import ComponentLoading from "@/components/global/component-loading";
import SubSeparator from "@/components/global/sub-separator";
import Icon from "@/components/icon";
import ProfilePicture from "@/components/user/profile-picture";
import { AbsentMember, AttendedMember, EventRequest, HonoredMember } from "@/TS/Interfaces/global_interfaces";
import { EventTypeText } from "@/TS/KeyMappings/global_key_mappings";
import { getHHhmmDateFormat } from "@/utils/formFunc/date-utils";
import { isPresident } from "@/utils/global-utils";
function EventReadDetail(t0) {
  const $ = _c(51);
  const {
    event,
    isLoading: t1,
    withMembersDetail: t2
  } = t0;
  const isLoading = t1 === undefined ? false : t1;
  const withMembersDetail = t2 === undefined ? true : t2;
  const [hasPresidentRole, setHasPresidentRole] = useState(false);
  let t3;
  let t4;
  if ($[0] !== event) {
    t3 = () => {
      if (!event) {
        return;
      }
      const fetchClub = async () => {
        const club = await getClubDashboard(event.clubSlug);
        setHasPresidentRole(club ? isPresident(club) : false);
      };
      fetchClub();
    };
    t4 = [event];
    $[0] = event;
    $[1] = t3;
    $[2] = t4;
  } else {
    t3 = $[1];
    t4 = $[2];
  }
  useEffect(t3, t4);
  if (!event) {
    let t5;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
      t5 = <ComponentLoading />;
      $[3] = t5;
    } else {
      t5 = $[3];
    }
    return t5;
  }
  let t5;
  if ($[4] !== event.type) {
    t5 = EventTypeText.get(event.type);
    $[4] = event.type;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== t5) {
    t6 = <h2 className="text-event text-lg font-bold mb-4 ">{t5}</h2>;
    $[6] = t5;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <Icon size={23} className="right-[calc(100%+1rem)]" icon="agenda" />;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== event.startDate) {
    t8 = new Date(event.startDate).toLocaleDateString(undefined, {
      weekday: "long",
      day: "numeric",
      month: "long",
      year: "numeric"
    });
    $[9] = event.startDate;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== t8) {
    t9 = <p className="font-bold relative flex gap-3 items-center capitalize">{t7}{" "}{t8}</p>;
    $[11] = t8;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <Icon className="right-[calc(100%+1rem)]" size={23} icon="time" />;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  let t11;
  if ($[14] !== event.startDate) {
    t11 = getHHhmmDateFormat(event.startDate);
    $[14] = event.startDate;
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  let t12;
  if ($[16] !== event.endDate) {
    t12 = getHHhmmDateFormat(event.endDate);
    $[16] = event.endDate;
    $[17] = t12;
  } else {
    t12 = $[17];
  }
  let t13;
  if ($[18] !== t11 || $[19] !== t12) {
    t13 = <p className=" flex relative gap-3 items-center ">{" "}{t10}{" "}{t11}{" - "}{t12}</p>;
    $[18] = t11;
    $[19] = t12;
    $[20] = t13;
  } else {
    t13 = $[20];
  }
  let t14;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <Icon className="right-[calc(100%+1rem)]" size={23} icon="localisation" />;
    $[21] = t14;
  } else {
    t14 = $[21];
  }
  let t15;
  if ($[22] !== event.postalAddress.place) {
    t15 = <p className="font-bold flex gap-3 items-center">{event.postalAddress.place}</p>;
    $[22] = event.postalAddress.place;
    $[23] = t15;
  } else {
    t15 = $[23];
  }
  let t16;
  if ($[24] !== event.postalAddress.street) {
    t16 = <p className="">{event.postalAddress.street}</p>;
    $[24] = event.postalAddress.street;
    $[25] = t16;
  } else {
    t16 = $[25];
  }
  let t17;
  if ($[26] !== event.postalAddress.city || $[27] !== event.postalAddress.zipCode) {
    t17 = <p className="">{event.postalAddress.zipCode} {event.postalAddress.city}</p>;
    $[26] = event.postalAddress.city;
    $[27] = event.postalAddress.zipCode;
    $[28] = t17;
  } else {
    t17 = $[28];
  }
  let t18;
  if ($[29] !== t15 || $[30] !== t16 || $[31] !== t17) {
    t18 = <div className="flex relative gap-3">{t14}<div className="flex flex-col">{t15}{t16}{t17}</div></div>;
    $[29] = t15;
    $[30] = t16;
    $[31] = t17;
    $[32] = t18;
  } else {
    t18 = $[32];
  }
  let t19;
  if ($[33] !== t13 || $[34] !== t18 || $[35] !== t9) {
    t19 = <div className="flex flex-col gap-2">{t9}{t13}{t18}</div>;
    $[33] = t13;
    $[34] = t18;
    $[35] = t9;
    $[36] = t19;
  } else {
    t19 = $[36];
  }
  let t20;
  if ($[37] !== t19 || $[38] !== t6) {
    t20 = <div className="flex flex-col">{t6}{t19}</div>;
    $[37] = t19;
    $[38] = t6;
    $[39] = t20;
  } else {
    t20 = $[39];
  }
  let t21;
  if ($[40] !== event.agenda) {
    t21 = event.agenda && <><SubSeparator className="mt-6" /><p className="font-bold uppercase">ordre du jour</p><p>{event.agenda}</p></>;
    $[40] = event.agenda;
    $[41] = t21;
  } else {
    t21 = $[41];
  }
  let t22;
  if ($[42] !== event || $[43] !== hasPresidentRole || $[44] !== isLoading || $[45] !== withMembersDetail) {
    t22 = withMembersDetail && <><SubSeparator className="mt-6" /><p className="font-bold flex items-center uppercase">Présents{" "}{!isLoading && event ? `(${event.attendedMembers.length})` : <span className="bg-dark-grey inline-block ml-1  w-6 h-6 font-bold text-lg text-white rounded-full aspect-square ease-in-out transition-all animate-pulse  items-center justify-center" />}</p><div className="flex mt-4 pl-4 gap-y-2 justify-left flex-wrap">{event && !isLoading ? event?.attendedMembers?.length !== 0 && event?.attendedMembers?.map(_temp) : new Array(18).fill(undefined).map(_temp2)}</div>{event.honoredMembers.length !== 0 && <><SubSeparator className="mt-6" /><p className="font-bold mb-4 uppercase">Membre à l'honneur ({event.honoredMembers.length})</p></>}<div className="flex flex-col gap-3">{event && event.honoredMembers.length !== 0 && event.honoredMembers.map(_temp3)}</div>{event?.requests?.length !== 0 && <><SubSeparator className="mt-6" /><p className="font-bold mb-4 uppercase">Invités ({event?.requests?.length ?? 0})</p></>}{event && event.requests && event.requests.length !== 0 && event.requests.map(_temp4)}{hasPresidentRole && event?.absentMembers && event?.absentMembers?.length !== 0 && <><SubSeparator className="mt-6" /><p className="font-bold uppercase">Absents ({event.absentMembers.length})</p><div className="flex flex-col mt-4 gap-2">{event && event?.absentMembers?.length !== 0 && event?.absentMembers?.map(_temp5)}</div></>}</>;
    $[42] = event;
    $[43] = hasPresidentRole;
    $[44] = isLoading;
    $[45] = withMembersDetail;
    $[46] = t22;
  } else {
    t22 = $[46];
  }
  let t23;
  if ($[47] !== t20 || $[48] !== t21 || $[49] !== t22) {
    t23 = <div className="flex flex-col px-8 py-6 rounded-lg bg-event bg-opacity-5">{t20}{t21}{t22}</div>;
    $[47] = t20;
    $[48] = t21;
    $[49] = t22;
    $[50] = t23;
  } else {
    t23 = $[50];
  }
  return t23;
}
function _temp5(t0, index_3) {
  const {
    firstName: firstName_2,
    lastName: lastName_2,
    avatar: avatar_2
  } = t0;
  return <div className="flex items-center gap-2" key={index_3}><ProfilePicture size={32} mobileSize={45} className="md:!text-[14px] text-base" firstName={firstName_2} lastName={lastName_2} src={avatar_2?.urls?.avatar_md} alt={firstName_2[0] + ". " + lastName_2} /><p className="font-bold h-fit">{firstName_2} {lastName_2}</p></div>;
}
function _temp4(t0, index_2) {
  const {
    firstName: firstName_1,
    lastName: lastName_1,
    avatar: avatar_1,
    jobTitle: jobTitle_0,
    companyName,
    activity
  } = t0;
  return <ProfileEvent firstName={firstName_1} lastName={lastName_1} key={index_2} avatar={avatar_1} jobTitle={jobTitle_0} organization={{
    name: companyName,
    activity
  }} />;
}
function _temp3(t0, index_1) {
  const {
    firstName: firstName_0,
    lastName: lastName_0,
    avatar: avatar_0,
    jobTitle,
    organization
  } = t0;
  return <ProfileEvent key={index_1} firstName={firstName_0} lastName={lastName_0} avatar={avatar_0} jobTitle={jobTitle} organization={organization} />;
}
function _temp2(res, index_0) {
  return <p key={index_0} className="font-bold text-lg aspect-square ease-in-out transition-all animate-pulse rounded-full ring-secondary relative -ml-4 bg-dark-grey text-white flex items-center justify-center h-12 w-12" style={{
    animationDelay: `${index_0 * 100}ms`
  }} />;
}
function _temp(t0, index) {
  const {
    firstName,
    lastName,
    avatar
  } = t0;
  return <ProfilePicture size={32} mobileSize={45} key={index} firstName={firstName} lastName={lastName} src={avatar?.urls?.avatar_md} alt={firstName[0] + ". " + lastName} className="-ml-2 md:!text-[14px] text-base" withTooltip={true} />;
}
export default EventReadDetail;